<style>
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Regular"),
    url(./fonts/Roboto-Regular.ttf) format("truetype");
  font-style: normal;
  font-weight: normal;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Bold"), url(./fonts/Roboto-Bold.ttf) format("truetype");
  font-style: normal;
  font-weight: bold;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Italic"), url(./fonts/Roboto-Italic.ttf) format("truetype");
  font-style: italic;
  font-weight: normal;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Light"), url(./fonts/Roboto-Light.ttf) format("truetype");
  font-style: normal;
  font-weight: lighter;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-LightItalic"),
    url(./fonts/Roboto-LightItalic.ttf) format("truetype");
  font-style: italic;
  font-weight: lighter;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-Medium"), url(./fonts/Roboto-Medium.ttf) format("truetype");
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Roboto";
  src: local("Roboto-MediumItalic"),
    url(./fonts/Roboto-MediumItalic.ttf) format("truetype");
  font-style: italic;
  font-weight: 500;
}
</style>
<template>
  <div>
    <div class="container" id="expeditionsVue" v-if="loaded">
      <div class="content">
        <principalHeader logoName="XPO" :logoImage="expedition.clientLogoUrl" />
        <div class="delivery-info" v-if="showStatusInfo">
          <div class="delivery-info-detail">
            <div
              class="delivery-info-banner"
              v-if="deliveryInfoBannerTextExist"
            >
              <span>{{ deliveryInfoBannerText }}</span>
            </div>
            <div class="delivery-info-data">
              <div class="delivery-change-date-button-container">
                <button
                  class="btn delivery-change-date-button"
                  v-if="
                    !actionsDisabled && scheduleAction && expedition.booking
                  "
                  v-on:click="schelude"
                >
                  {{
                    requestedDeliveryDateSlotExists
                      ? $t("xpo.button.changeDate")
                      : $t("xpo.button.setDate")
                  }}
                </button>
              </div>
              <div
                class="delivery-date"
                v-if="requestedDeliveryDateSlotExists && expedition.booking"
              >
                <span class="delivery-date-row-1">{{
                  this.isPickup ? $t("xpo.pickupInfo") : $t("xpo.deliveryInfo")
                }}</span>
                <span class="delivery-date-row-2">{{
                  requestedDeliveryDateSlot
                }}</span>
                <span class="delivery-date-row-3">{{
                  requestedDeliveryDateHour
                }}</span>
                <font-awesome-icon
                  icon="calendar"
                  class="far fa-calendar-alt item__download"
                  v-on:click="calendarDownload"
                  v-if="calendarInit"
                />
              </div>
              <div class="delivery-info-detail-consignee">
                <div class="delivery-consignee-change-container">
                  <div class="delivery-consignee-change-title">
                    {{
                      this.isPickup
                        ? $t("destination.pickup")
                        : $t("destination")
                    }}
                  </div>
                  <div
                    class="delivery-consignee-change-button"
                    v-if="
                      !actionsDisabled && scheduleAction && expedition.booking
                    "
                  >
                    <button class="btn" v-on:click="changeConsignee">
                      {{ $t("xpo.button.change") }}
                    </button>
                  </div>
                </div>
                <div class="delivery-consignee-info" v-if="this.isPickup">
                  <span>{{ expedition.senderName }}</span>
                  <span>{{ expedition.senderCity }}</span>
                  <span
                    >{{ expedition.senderPostalCode }}
                    {{ expedition.senderCountry }}</span
                  >
                </div>
                <div class="delivery-consignee-info" v-else>
                  <span>{{ expedition.consigneeName }}</span>
                  <span>{{ expedition.consigneeCity }}</span>
                  <span
                    >{{ expedition.consigneePostalCode }}
                    {{ expedition.consigneeCountry }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="delivery-info-status">
            <div class="delivery-status-progress-background"></div>
            <ul
              class="delivery-status-progress consignment_type_pickup"
              :class="statusStep"
              v-if="this.isPickup"
            >
              <li class="delivery-status-item delivery-status-step-1">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("pickup.ORIG") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-2">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("pickup.CERR") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-3">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("pickup.REPA") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-4">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("pickup.EFEC") }}</p>
              </li>
            </ul>
            <ul
              class="delivery-status-progress consignment_type_delivery"
              :class="statusStep"
              v-else
            >
              <li class="delivery-status-item delivery-status-step-1">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("ORIG") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-2">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("CERR") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-3">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("PEND") }}</p>
              </li>
              <li class="delivery-status-item delivery-status-step-4">
                <div class="delivery-status-circle"></div>
                <p>{{ $t("REPA") }}</p>
              </li>
              <li
                class="delivery-status-item delivery-status-step-5"
                :class="checkStatusDelivered"
              >
                <div class="delivery-status-circle"></div>
                <p>{{ checkStatusDeliveredText }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="delivery-intime-container" v-else>
          <div class="delivery-intime-general">
            <div class="delivery-intime-time">
              <p class="time-title">{{ $t("xpo.deliveryTime") }}</p>
              <p class="time-slot-value">
                {{ this.mountTimeSlot() }}
              </p>
            </div>
            <div class="delivery-intime-status">
              <div class="status-icon" :class="statusStep"></div>
              <p class="status-value">
                {{
                  this.$t(this.isPickup ? "pickup." + this.status : this.status)
                }}
              </p>
              <p class="time-title">{{ $t("xpo.estimatedArrival") }}</p>
              <p class="time-value">{{ requestedDeliveryDateHour }}</p>
            </div>
          </div>
          <div
            class="delivery-intime-map"
            v-if="
              this.gps.driverPosition != null &&
                this.gps.deliveryPosition != null
            "
          >
            <HereMap
              :deliveryPosition="this.gps.deliveryPosition"
              :driverPosition="this.gps.driverPosition"
            />
          </div>
          <div class="delivery-intime-driver" v-if="gps.driverName != null">
            <div class="driver-info">
              <div class="driver-info-name">
                <div class="driver-info-title">
                  {{ $t("driverInformation.driverName") }}
                </div>
                <div class="driver-info-value">{{ gps.driverName }}</div>
              </div>
              <div class="driver-info-vehicle-interface">
                <div class="driver-info-title">
                  {{ $t("driverInformation.vehicleInterface") }}
                </div>
                <div class="driver-info-value">{{ gps.vehicleInterface }}</div>
              </div>
              <div class="driver-info-vehicle">
                <div class="driver-info-title">
                  {{ $t("driverInformation.vehicle") }}
                </div>
                <div class="driver-info-value">
                  {{ gps.vehicleType }} - {{ gps.vehicleBrand }}
                </div>
              </div>
            </div>
            <div class="delivery-intime-driver-photo">
              <img
                alt=""
                :src="gps.urlDriverImage"
                class="driver-principal-photo"
              />
              <img
                alt=""
                :src="gps.urlAccompanyingDriverImage"
                class="driver-secondary-photo"
              />
            </div>
          </div>
        </div>

        <div
          class="delivery-tracking"
          :class="
            'REPA' == this.status
              ? 'delivery-tracking-repa'
              : ''
          "
        >
          <div class="delivery-tracking-address">
            <p class="delivery-tracking-address-title">
              {{ $t("xpo.deliveryFrom") }}
            </p>
            <p class="delivery-tracking-address-value">
              {{
                this.isPickup ? expedition.consigneeName : expedition.senderName
              }}
            </p>
          </div>
          <div class="delivery-tracking-address" v-if="!showStatusInfo">
            <p class="delivery-tracking-address-title">
              {{ $t("destination") }}
            </p>
            <p class="delivery-tracking-address-value">
              {{ expedition.consigneeName }}
            </p>
            <p class="delivery-tracking-address-value">
              {{ expedition.consigneeAddress }}
            </p>
            <p class="delivery-tracking-address-value">
              {{ expedition.consigneePostalCode }}
            </p>
          </div>
          <div
            class="delivery-tracking-number"
            :class="
              'REPA' == this.status
                ? 'delivery-tracking-number-repa'
                : ''
            "
            v-if="showStatusInfo || 'REPA' == this.status"
          >
            <p class="delivery-tracking-number-title">
              {{ $t("xpo.shipment") }}
            </p>
            <p class="delivery-tracking-number-value">
              #{{ expedition.deliveryOrderId }}
            </p>
          </div>
        </div>
        <div class="delivery-tracking-actions">
          <button
            v-on:click="toogleWindow('showModalDetails')"
            class="btn btn--white"
          >
            {{ $t("xpo.button.showDetails") }}
          </button>
          <button
            class="btn btn--white"
            v-on:click="toogleWindow('showModalDocuments')"
            v-if="this.documents !== undefined && this.documents.length > 0"
          >
            {{ $t("documents") }}
          </button>
          <button
            class="btn btn--white"
            v-on:click="toogleWindow('showModalArticles')"
            v-if="
              expedition.articles !== undefined &&
                expedition.articles.length > 0 &&
                !this.isPickup
            "
          >
            {{ $t("articles") }}
          </button>
          <button
            class="btn btn--white"
            v-on:click="toogleWindow('showModalOperations')"
            v-if="
              expedition.operations !== undefined &&
                expedition.operations.length > 0 &&
                !this.isPickup
            "
          >
            {{ $t("xpo.operations") }}
          </button>
        </div>
      </div>
    </div>
    <modalDialog
      class="modal--personalized"
      v-if="showModal"
      @close="closeDialog"
    >
      <p class="" slot="header">
        {{
          this.isPickup
            ? $t("change.dialog.title.pickup")
            : $t("change.dialog.title")
        }}
      </p>
      <div slot="form" class="form">
        <div class="form__row">
          <div class="form__title">{{ $t("change.dialog.name") }}</div>
          <div class="form__field">
            <input
              ref="modifyConsigneeName"
              type="text"
              width="100"
              v-model="consigneeNameModify"
              class="form-input"
              maxlength="60"
            />
          </div>
        </div>

        <div class="form__row">
          <div class="form__title">{{ $t("change.dialog.address") }}</div>
          <div class="form__field">
            <input
              ref="modifyConsigneeAddress"
              type="text"
              v-model="consigneeAddressModify"
              class="form-input"
              maxlength="60"
            />
          </div>
        </div>

        <div class="form__row">
          <div class="form__title">
            {{ $t("xpo.change.dialog.observations") }}
          </div>
          <div class="form__field">
            <textarea
              ref="modifyObservations"
              v-model="observations1Modify"
              rows="2"
              @keydown="maxlengthTextArea"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button save class="btn btn--red modal__btn" @click="update">
          {{ $t("global.button.save") }}
        </button>
        <button cancel class="btn btn--white modal__btn" @click="closeDialog">
          {{ $t("global.button.cancel") }}
        </button>
      </div>
    </modalDialog>

    <dialogArticles
      :articles="this.expedition.articles"
      @close="toogleWindow('showModalArticles')"
      v-if="showModalArticles"
    />

    <dialogDocuments
      :documents="this.documents"
      @close="toogleWindow('showModalDocuments')"
      v-if="showModalDocuments"
    />

    <dialogOperations
      :operations="this.expedition.operations"
      @close="toogleWindow('showModalOperations')"
      v-if="showModalOperations"
    />

    <dialogDetails
      :expedition="this.expedition"
      :actionsEnabled="this.scheduleAction"
      @save="saveAdditionalService"
      @close="toogleWindow('showModalDetails')"
      v-if="showModalDetails"
    />

    <dialogCollectDataConfirmService
      :uuid="this.uuid"
      :additionalServicesSelected="this.additionalServicesSelected"
      @close="closeAndReload('showModalServicePurchased')"
      @back="backToDialogAddService"
      @showPersonalData="showLegalPersonalData"
      v-show="showModalCollectDataService"
      ref="dialogCollectData"
    />

    <dialogServicePurchased
      :status="this.$route.query.tpvConfirm === 'true' || freePurchase"
      @close="reload()"
      v-if="showModalServicePurchased || freePurchase"
    />

    <dialogLegalPersonalData
      @close="toogleWindow('showModalLegalPersonalData')"
      v-if="showModalLegalPersonalData"
    />

    <loading v-if="loadingAction"></loading>

    <confirmDlg
      class="message_dialog"
      v-if="showMessageDialog"
      @close="closeMessageDialog"
    >
      <p slot="header">{{ $t("global.error") }}</p>
      <p slot="form">{{ $t("global.error.genericMessage") }}</p>
    </confirmDlg>
  </div>
</template>

<style scoped src="./css/override-components.css"></style>
<style scoped src="./css/common.css"></style>
<style scoped src="./css/expeditions.css"></style>

<script>
import Vue from "vue";
import { localhttp } from "@/http-commons";
import statusjs from "@/js/statusVariables";
import HereMap from "@/components/HereMap.vue";
import modalDialog from "@/components/ModalDialogFrame.vue";
import confirmDlg from "@/components/MessageDialog.vue";
import loading from "@/components/Loading.vue";
import ICS from "vue-ics";

import dialogArticles from "./DialogArticles.vue";
import dialogDocuments from "./DialogDocuments.vue";
import dialogOperations from "./DialogOperations.vue";
import dialogDetails from "./DialogDetails.vue";
import dialogCollectDataConfirmService from "./DialogCollectDataConfirmService.vue";
import dialogServicePurchased from "./DialogServicePurchased.vue";
import dialogLegalPersonalData from "./DialogLegalPersonalData.vue";
import principalHeader from "./Header.vue";

Vue.use(ICS);

const CONTEXT = "/public/expeditions";
const PROGRESS_TOTAL = 3;
const EMPTY_STRING = "\xa0";

export default {
  name: "expeditions",
  components: {
    HereMap,
    modalDialog,
    confirmDlg,
    loading,
    dialogArticles,
    dialogDocuments,
    dialogOperations,
    dialogDetails,
    dialogCollectDataConfirmService,
    dialogServicePurchased,
    dialogLegalPersonalData,
    principalHeader
  },
  props: {
    uuid: {
      type: String,
      required: false
    },
    lang: {
      type: String,
      required: false
    },
    tpvConfirm: {
      type: String,
      required: false
    }
  },
  data: () => ({
    freePurchase: false,
    progress: 0,
    loaded: false,
    actionsDisabled: true,
    status: "",
    gpsStatus: false,
    apiDate: false,
    gpsDate: null,
    statusDate: null,
    timeSlotDate: null,
    timeSlotDateFrom: null,
    timeSlotDateTo: null,
    statusStep: 0,
    statusUndelivered: false,
    scheduleAction: false,
    gps: {
      deliveryPosition: null,
      driverPosition: null,
      status: null,
      driverAvalible: false,
      driverInterface: null,
      driverName: null,
      driverPhone: null,
      vehicleInterface: null,
      vehicleType: null,
      vehicleBrand: null,
      urlDriverImage: null,
      urlAccompanyingDriverImage: null,
      deliveryNumberStops: null
    },
    expedition: {
      organizationCode: "",
      deliveryOrderId: "",
      reference1: "",
      reference2: "",
      packageNumber: "",
      senderCode: "",
      senderTaxId: "",
      senderName: "",
      senderName2: "",
      senderAddress: "",
      senderAddress2: "",
      senderCountry: "",
      senderPostalCode: "",
      senderCity: "",
      senderTelephone: "",
      senderContactPerson: "",
      senderEmail: "",
      consigneeCode: "",
      consigneeTaxId: "",
      consigneeName: "",
      consigneeName2: "",
      consigneeAddress: "",
      consigneeAddress2: "",
      consigneeCountry: "",
      consigneePostalCode: "",
      consigneeCity: "",
      consigneeTelephone: "",
      consigneeContactPerson: "",
      consigneeEmail: "",
      serviceId: "",
      serviceName: "",
      weight: "",
      volume: "",
      refoundAmount: "",
      refoundCurrency: "",
      valueAmount: "",
      valueCurrency: "",
      incoterms: "",
      incotermsDescription: "",
      observations1: "",
      observations2: "",
      goodsDescription: "",
      palletNumber: "",
      requestedDeliveryDateFrom: "",
      requestedDeliveryDateTo: "",
      plannedDeliveryDateFrom: "",
      plannedDeliveryDateTo: "",
      companyDivision: "",
      status: "",
      statusDate: "",
      scheludeToken: "",
      language: "",
      consignmentType: "",
      requestedCollectionDateFrom: "",
      requestedCollectionDateTo: "",
      plannedCollectionDateFrom: "",
      plannedCollectionDateTo: "",
      clientLogoUrl: ""
    },
    requestedDeliveryDateText: null,
    requestedDeliveryDateWeekday: null,
    requestedDeliveryDateSlot: null,
    requestedDeliveryDateHour: null,
    consigneeNameModify: "",
    consigneeAddressModify: "",
    consigneeAddress2Modify: "",
    observations1Modify: "",
    displayParametrization: {
      showMap: true
    },
    showModal: false,
    showModalArticles: false,
    showModalDocuments: false,
    showModalOperations: false,
    showModalDetails: false,
    showModalCollectDataService: false,
    showModalServicePurchased: false,
    showModalLegalPersonalData: false,
    showMessageDialog: false,
    loadingAction: false,
    additionalServicesSelected: null,
    calendarInit: false,
    documents: [],
    enableChangeDate: true
  }),
  watch: {
    status: function(value) {
      this.statusUndelivered = false;
      this.scheduleAction = false;
      var cssStatusStep = "delivery-status-complete-step-";
      var step = 1;

      this.scheduleAction =
        [this.isPickup ? statusjs.PENDING : statusjs.TRANSIT].indexOf(value) >=
        0;

      if (this.isPickup) {
        if (value === statusjs.TRANSIT) {
          step = 2;
        }

        if (value === statusjs.DELIVERY) {
          step = 3;
        }

        if (value === statusjs.DELIVERED) {
          step = 4;
        }
      } else {
        if (value === statusjs.TRANSIT) {
          step = 2;
        }

        if (value === statusjs.ARRIVED) {
          step = 3;
        }

        if (value === statusjs.DELIVERY) {
          step = 4;
        }

        if (value === statusjs.DELIVERED) {
          step = 5;
        }

        if (value === statusjs.UNDELIVERED) {
          this.statusUndelivered = true;
          step = 5;
        }

        if (value === statusjs.CANCELL) {
          step = "cancelled";
        }
      }

      this.statusStep = cssStatusStep + step;
    },
    progress: function(value) {
      if (value === PROGRESS_TOTAL) {
        this.statusDateControll();
        this.actionsDisabled = false;
      }
    }
  },
  computed: {
    checkStatusDelivered() {
      return this.statusUndelivered ? "failStatus" : "rightStatus";
    },
    checkStatusDeliveredText() {
      return this.statusUndelivered
        ? this.$t(statusjs.UNDELIVERED)
        : this.$t(statusjs.DELIVERED);
    },
    requestedDeliveryDateSlotExists() {
      return (
        this.requestedDeliveryDateSlot != null &&
        this.requestedDeliveryDateSlot != EMPTY_STRING
      );
    },
    deliveryInfoBannerTextExist() {
      return this.deliveryInfoBannerText != null;
    },
    deliveryInfoBannerText() {
      var returnText = this.requestedDeliveryDateText;
      if (this.expedition.booking) {
        if (
          [
            statusjs.PENDING,
            statusjs.TRANSIT,
            statusjs.ARRIVED,
            statusjs.DELIVERY
          ].indexOf(this.status) >= 0
        ) {
          if (!this.scheduleAction) {
            returnText =
              (returnText === null ? "" : returnText + "\n") +
              (this.isPickup
                ? this.$t("xpo.pickupDateNoEditable")
                : this.$t("xpo.deliveryDateNoEditable"));
          }
        }
      } else {
        returnText = this.isPickup
          ? this.$t("xpo.pickupDateNoEditable")
          : this.$t("xpo.deliveryDateNoEditable");
      }
      return returnText;
    },
    showStatusInfo() {
      return (
        [
          statusjs.PENDING,
          statusjs.TRANSIT,
          statusjs.ARRIVED,
          statusjs.DELIVERED,
          statusjs.UNDELIVERED,
          statusjs.CANCELL
        ].indexOf(this.status) >= 0 || this.isPickup
      );
    },
    deliveryNumberStopsText() {
      if (this.gps.deliveryNumberStops !== null) {
        if (this.gps.deliveryNumberStops === 0) {
          return this.$t("xpo.deliveryNumberStops.nextStop");
        } else if (this.gps.deliveryNumberStops === 1) {
          return (
            this.gps.deliveryNumberStops +
            " " +
            this.$t("xpo.deliveryNumberStops.singular")
          );
        } else {
          return (
            this.gps.deliveryNumberStops +
            " " +
            this.$t("xpo.deliveryNumberStops.plural")
          );
        }
      }
      return "";
    },
    isPickup() {
      return this.expedition.consignmentType === "PICKUP";
    }
  },
  methods: {
    async searchExpedition(token, consigneePostalCode) {
      this.progress = 0;
      if (token !== null && consigneePostalCode !== null) {
        var tokenMatch;
        try {
          // Validate token MD5
          let tokenRegex = new RegExp("^\\d{0,10}[A-Z]{4}");
          tokenMatch = tokenRegex.exec(token).toString();
          var tokenMD5 = require("crypto")
            .createHash("md5")
            .update(tokenMatch.toString())
            .digest("hex");
          tokenMD5 = tokenMD5
            .substring(0, 16 - tokenMatch.length)
            .toUpperCase();
          tokenMatch = tokenMatch + tokenMD5;
        } catch (ex) {
          console.error(ex);
        }
        if (tokenMatch === token) {
          localhttp
            .get(CONTEXT + "/" + token + "/" + consigneePostalCode)
            .then(response => {
              this.expedition = response.data;
              this.expedition.language = this.$i18n.locale;
              if (this.gpsStatus === false) {
                this.status = this.expedition.status;
              }
              if (this.expedition.statusDate !== undefined) {
                this.statusDate = this.expedition.statusDate;
              }
              if (this.isPickup) {
                if (this.expedition.requestedCollectionDateFrom !== undefined) {
                  this.timeSlotDate = this.expedition.requestedCollectionDateFrom;
                  this.timeSlotDateFrom = this.expedition.requestedCollectionDateFrom;
                  this.timeSlotDateTo = this.expedition.requestedCollectionDateTo;
                }
              } else {
                if (this.expedition.requestedDeliveryDateFrom !== undefined) {
                  this.timeSlotDate = this.expedition.requestedDeliveryDateFrom;
                  this.timeSlotDateFrom = this.expedition.requestedDeliveryDateFrom;
                  this.timeSlotDateTo = this.expedition.requestedDeliveryDateTo;
                }
              }
            })
            .catch(e => {
              console.log(this.$t("shipment.notFound"), e);
              this.loaded = true;
              this.expedition.deliveryOrderId = "";
            })
            .finally(() => {
              this.loaded = true;
              this.progress++;
            });

          localhttp
            .get(CONTEXT + "/status/" + token + "/" + consigneePostalCode)
            .then(response => {
              //no update status if gps status
              if (this.gpsStatus === false) {
                this.status = response.data.status;
              }
              if (response.data.statusDate !== undefined) {
                this.statusDate = response.data.statusDate;
              }
            })
            .catch(e => {
              console.log(this.$t("status.notFound"), e);
            })
            .finally(() => {
              this.progress++;
            });

          localhttp
            .get(CONTEXT + "/gps/" + token + "/" + consigneePostalCode)
            .then(response => {
              //Only type E (expeditions) are allowed
              if ("E" === response.data.type) {
                if (
                  [
                    statusjs.ARRIVED,
                    statusjs.DELIVERY,
                    statusjs.DELIVERED
                  ].indexOf(response.data.deliveryStatus) >= 0
                ) {
                  this.gps.driverPosition = response.data.driverPosition;
                }
                this.gps.deliveryPosition = response.data.deliveryPosition;

                //Only valid status
                if (
                  [
                    statusjs.ARRIVED,
                    statusjs.DELIVERY,
                    "ENTR",
                    statusjs.UNDELIVERED,
                    statusjs.DELIVERED
                  ].indexOf(response.data.deliveryStatus) >= 0
                ) {
                  if (response.data.estimatedTimeArrival !== undefined) {
                    this.gpsDate = response.data.estimatedTimeArrival;
                  }
                  this.gpsStatus = true;
                  //translate status
                  this.status =
                    "ENTR" == response.data.deliveryStatus
                      ? statusjs.DELIVERED
                      : response.data.deliveryStatus;
                }

                // Image driver
                if (response.data.driverName) {
                  this.gps.driverAvalible = true;
                  this.gps.driverInterface = response.data.driverInterface;
                  this.gps.driverName = response.data.driverName;
                  this.gps.driverPhone = response.data.driverPhone;
                  this.gps.vehicleInterface = response.data.vehicleInterface;
                  this.gps.vehicleType = response.data.vehicleType;
                  this.gps.vehicleBrand = response.data.vehicleBrand;
                  this.gps.urlDriverImage = response.data.urlDriverImage;
                  this.gps.urlAccompanyingDriverImage =
                    response.data.urlAccompanyingDriverImage;
                  this.gps.deliveryNumberStops =
                    response.data.deliveryNumberStops;
                } else {
                  this.gps.driverAvalible = false;
                }
              }
            })
            .catch(e => {
              console.log(this.$t("gps.notFound"), e);
            })
            .finally(() => {
              this.progress++;
            });

          localhttp
            .get(CONTEXT + "/documents/" + token)
            .then(response => {
              if (response.data.imagenes !== undefined) {
                this.documents = response.data.imagenes;
              }
            })
            .catch(e => {
              console.log(this.$t("documents.notFound"), e);
            })
            .finally(() => {
              this.progress++;
            });
        }
      }
    },
    schelude() {
      this.$plausible.trackEvent("schedule");
      var urlReservation =
        process.env.VUE_APP_TIME_SLOT_RESERVATION_URL +
        "?" +
        "token=" +
        this.$route.params.token +
        "&zipCode=" +
        this.$route.params.consigneePostalCode +
        "&lang=" +
        this.$i18n.locale;
      if (this.$route.query.uuid != undefined) {
        urlReservation = urlReservation + "&uuid=" + this.$route.query.uuid;
      }
      window.location.href = urlReservation;
    },
    changeConsignee() {
      this.$plausible.trackEvent("changeConsignee");
      if (this.isPickup) {
        this.consigneeNameModify = this.expedition.senderName;
        this.consigneeAddressModify = this.expedition.senderAddress;
        this.consigneeAddress2Modify = this.expedition.senderAddress2;
      } else {
        this.consigneeNameModify = this.expedition.consigneeName;
        this.consigneeAddressModify = this.expedition.consigneeAddress;
        this.consigneeAddress2Modify = this.expedition.consigneeAddress2;
      }
      this.observations1Modify = this.expedition.observations1;
      this.showDialog();
    },
    update() {
      this.$plausible.trackEvent("updateConsignee");
      if (
        this.consigneeNameModify == undefined ||
        this.consigneeNameModify.length === 0
      ) {
        this.$refs.modifyConsigneeName.focus();
        return;
      }
      if (
        this.consigneeAddressModify == undefined ||
        this.consigneeAddressModify.length === 0
      ) {
        this.$refs.modifyConsigneeAddress.focus();
        return;
      }
      this.openLoading();
      if (this.isPickup) {
        localhttp
          .post(
            CONTEXT +
              "/updateSender/" +
              this.$route.params.token +
              "/" +
              this.$route.params.consigneePostalCode,
            {
              senderName: this.consigneeNameModify,
              senderAddress: this.consigneeAddressModify,
              senderAddress2: this.consigneeAddress2Modify,
              observations1: this.observations1Modify,
              token: this.expedition.token,
              uuid: this.$route.query.uuid
            }
          )
          .then(response => {
            this.closeLoading();
            this.expedition.senderName = response.data.senderName;
            this.expedition.senderAddress = response.data.senderAddress;
            this.expedition.senderAddress2 = response.data.senderAddress2;
            this.expedition.observations1 = response.data.observations1;
            this.closeDialog();
          })
          .catch(e => {
            console.log("Error: ", e);
            this.closeLoading();
            this.openMessageDialog();
          });
      } else {
        localhttp
          .post(
            CONTEXT +
              "/updateConsignee/" +
              this.$route.params.token +
              "/" +
              this.$route.params.consigneePostalCode,
            {
              consigneeName: this.consigneeNameModify,
              consigneeAddress: this.consigneeAddressModify,
              consigneeAddress2: this.consigneeAddress2Modify,
              observations1: this.observations1Modify,
              token: this.expedition.token,
              uuid: this.$route.query.uuid
            }
          )
          .then(response => {
            this.closeLoading();
            this.expedition.consigneeName = response.data.consigneeName;
            this.expedition.consigneeAddress = response.data.consigneeAddress;
            this.expedition.consigneeAddress2 = response.data.consigneeAddress2;
            this.expedition.observations1 = response.data.observations1;
            this.closeDialog();
          })
          .catch(e => {
            console.log("Error: ", e);
            this.closeLoading();
            this.openMessageDialog();
          });
      }
    },
    showDialog() {
      this.showModal = true;
      this.$nextTick(() => {
        this.$refs.modifyConsigneeName.focus();
      });
    },
    closeDialog() {
      this.showModal = false;
    },
    openMessageDialog() {
      this.showMessageDialog = true;
    },

    closeMessageDialog() {
      this.showMessageDialog = false;
    },
    openLoading() {
      this.loadingAction = true;
    },
    closeLoading() {
      this.loadingAction = false;
    },
    maxlengthTextArea(evt) {
      if (this.observations1Modify.length >= 200) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          evt.preventDefault();
          return;
        }
      }
    },
    initCalendarDownload() {
      if (this.timeSlotDate !== null) {
        var subject = this.$t("xpo.calendar.subject", {
          client: this.expedition.senderName,
          deliveryOrder: this.expedition.deliveryOrderId
        });
        var description = this.$t("xpo.calendar.description", {
          client: this.expedition.senderName,
          deliveryOrder: this.expedition.deliveryOrderId,
          direction:
            this.expedition.consigneeAddress +
            ", " +
            this.expedition.consigneePostalCode +
            ", " +
            this.expedition.consigneeCity +
            ", " +
            this.expedition.consigneeCountry
        });
        var location =
          this.expedition.consigneeAddress +
          ", " +
          this.expedition.consigneePostalCode +
          ", " +
          this.expedition.consigneeCity +
          ", " +
          this.expedition.consigneeCountry;
        this.$ics.addEvent(
          this.$i18n.locale,
          subject,
          description,
          location,
          this.isPickup
            ? this.expedition.requestedCollectionDateFrom
            : this.expedition.requestedDeliveryDateFrom,
          this.isPickup
            ? this.expedition.requestedCollectionDateTo
            : this.expedition.requestedDeliveryDateTo,
          window.location.href,
          null,
          null
        );
        this.calendarInit = true;
      }
    },
    calendarDownload() {
      this.$ics.download("delivery" + this.expedition.deliveryOrderId);
    },
    statusDateControll() {
      this.requestedDeliveryDateText = null;
      this.requestedDeliveryDateWeekday = EMPTY_STRING;
      this.requestedDeliveryDateSlot = EMPTY_STRING;
      this.requestedDeliveryDateHour = EMPTY_STRING;
      if ([statusjs.PENDING, statusjs.TRANSIT].indexOf(this.status) >= 0) {
        //PREPARING OR TRANSIT
        if (
          this.expedition.scheludeToken !== null &&
          this.timeSlotDate !== null
        ) {
          let date = Date.parse(this.timeSlotDate);
          this.requestedDeliveryDateText = this.isPickup
            ? this.$t("xpo.agreedPickupDate")
            : this.$t("xpo.agreedDeliveryDate");
          this.requestedDeliveryDateWeekday = this.$d(date, "dayText");
          this.requestedDeliveryDateSlot =
            this.$d(date, "dayShort") + " " + this.$d(date, "monthText");
          this.requestedDeliveryDateHour = this.mountTimeSlot();
        } else if (statusjs.TRANSIT === this.status) {
          this.requestedDeliveryDateText = this.$t("xpo.requestDatePending");
        }
      } else if (statusjs.ARRIVED === this.status) {
        //ARRIVED
        if (this.timeSlotDate !== null) {
          let date = Date.parse(this.timeSlotDate);
          this.requestedDeliveryDateWeekday = this.$d(date, "dayText");
          this.requestedDeliveryDateSlot =
            this.$d(date, "dayShort") + " " + this.$d(date, "monthText");
          this.requestedDeliveryDateHour = this.mountTimeSlot();
          // If timeSlotDate > today + 2 then show schedule actions
          let today = new Date();
          today.setDate(today.getDate() + 2);
          today.setHours(0, 0, 0, 0);
          let scheduleDate = new Date(date);
          scheduleDate.setHours(0, 0, 0, 0);
          if (today <= scheduleDate) {
            this.scheduleAction = true;
            this.requestedDeliveryDateText = this.$t("xpo.requestDatePending");
          }
        }
      } else if (statusjs.DELIVERY === this.status) {
        //DELIVERY
        if (this.timeSlotDate !== null) {
          let date = Date.parse(this.timeSlotDate);
          this.requestedDeliveryDateText = this.isPickup
            ? this.$t("xpo.agreedPickupDate")
            : this.$t("xpo.agreedDeliveryDate");
          this.requestedDeliveryDateWeekday = this.$d(date, "dayText");
          this.requestedDeliveryDateSlot =
            this.$d(date, "monthText") + " " + this.$d(date, "dayShort");
          this.requestedDeliveryDateHour = this.mountTimeSlot();
        }
        if (this.gpsDate !== null) {
          this.requestedDeliveryDateHour = this.getHour(
            new Date(Date.parse(this.gpsDate))
          );
        }
      } else if (statusjs.DELIVERED === this.status) {
        //DELIVERED
        if (this.statusDate !== null) {
          let date = new Date(Date.parse(this.statusDate));
          this.requestedDeliveryDateWeekday = this.$d(date, "dayText");
          this.requestedDeliveryDateSlot =
            this.$d(date, "monthText") + " " + this.$d(date, "dayShort");
          this.requestedDeliveryDateHour = this.getHour(date);
        }
      } else if (
        [statusjs.CANCELL, statusjs.UNDELIVERED].indexOf(this.status) >= 0
      ) {
        //UNDELIVERED OR CANCELLED
        if (this.statusDate !== null) {
          let date = Date.parse(this.statusDate);
          this.requestedDeliveryDateWeekday = this.$d(date, "dayText");
          this.requestedDeliveryDateSlot =
            this.$d(date, "monthText") + " " + this.$d(date, "dayShort");
        }
      }
      if (this.requestedDeliveryDateHour !== null) {
        this.initCalendarDownload();
      }
    },
    mountTimeSlot() {
      if (
        this.timeSlotDateFrom == undefined ||
        this.timeSlotDateTo == undefined
      ) {
        return "";
      } else {
        let requestedDeliveryHourFrom = this.$d(
          Date.parse(this.timeSlotDateFrom),
          "hourShort"
        );
        let requestedDeliveryHourTo = this.$d(
          Date.parse(this.timeSlotDateTo),
          "hourShort"
        );
        return requestedDeliveryHourFrom + " - " + requestedDeliveryHourTo;
      }
    },
    getHour(date) {
      return (
        date.getHours() +
        ":" +
        (date.getMinutes() < 10 ? "0" : "") +
        date.getMinutes()
      );
    },
    saveAdditionalService(additionalServicesSelected) {
      this.additionalServicesSelected = additionalServicesSelected;
      this.toogleWindow("showModalDetails");
      this.toogleWindow("showModalCollectDataService");
      var dialogCollectDataService = this.$refs.dialogCollectData;
      dialogCollectDataService.loadForm(this.expedition);
    },
    backToDialogAddService() {
      this.toogleWindow("showModalCollectDataService");
      this.toogleWindow("showModalDetails");
    },
    showLegalPersonalData() {
      this.toogleWindow("showModalLegalPersonalData");
    },
    closeAndReload(target) {
      this.toogleWindow(target);
      this.toogleWindow("showModalCollectDataService");
    },
    reload() {
      this.freePurchase = false;
      this.searchExpedition(
        this.$route.params.token,
        this.$route.params.consigneePostalCode
      );
      this.toogleWindow("showModalServicePurchased");
      this.$forceUpdate();
    },
    toogleWindow(target) {
      this[target] = !this[target];
      if (this[target]) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
      }
    }
  },
  beforeMount() {
    this.searchExpedition(
      this.$route.params.token,
      this.$route.params.consigneePostalCode
    );

    if (this.$route.query.lang != null) {
      this.$i18n.locale = this.$route.query.lang;
    }
    if (this.$route.query.tpvConfirm != null) {
      this.showModalServicePurchased = true;
    }
  }
};
</script>
